"use strict";

module.exports = require("./Box.js");